import { render, staticRenderFns } from "./Notificationbell.vue?vue&type=template&id=222fb023"
import script from "./Notificationbell.vue?vue&type=script&lang=js"
export * from "./Notificationbell.vue?vue&type=script&lang=js"
import style0 from "./Notificationbell.vue?vue&type=style&index=0&id=222fb023&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports